var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaestro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 3.5,
    stroke: "#FFFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6768 15.6077C25.6768 20.5456 21.7197 24.5487 16.8384 24.5487C11.9571 24.5487 8 20.5456 8 15.6077C8 10.6697 11.9571 6.66666 16.8384 6.66666C21.7197 6.66666 25.6768 10.6697 25.6768 15.6077Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1429 15.6077C37.1429 20.5456 33.1858 24.5487 28.3045 24.5487C23.4232 24.5487 19.4661 20.5456 19.4661 15.6077C19.4661 10.6697 23.4232 6.66666 28.3045 6.66666C33.1858 6.66666 37.1429 10.6697 37.1429 15.6077Z",
    fill: "#0099DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5713 22.413C24.4718 20.7731 25.6768 18.3328 25.6768 15.6078C25.6768 12.8828 24.4718 10.4425 22.5713 8.80258C20.6709 10.4425 19.4658 12.8828 19.4658 15.6078C19.4658 18.3328 20.6709 20.7731 22.5713 22.413Z",
    fill: "#6C6BBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaestro);
export default __webpack_public_path__ + "static/media/maestro.3ef09e5f85d3c4e00bcbec5138db2585.svg";
export { ForwardRef as ReactComponent };